<vb-confirmation-dialog [title]="'InitiateDownload' | translate" [message]="'InitiateDownload_Confirmation' | translate" [actionText]="'Ok' | translate" [themed]="true">
</vb-confirmation-dialog>
<report-grid-wrapper [header]="header" [headerTag]="'h4'" [accountId]="accountId" [type]="GridType.EVENTS" [headerTemplate]="headerTemplate">

	<vb-ui-infinite-scroll-grid [ngClass]="styles.grid" [columnDefs]="columnDefs" [getRows]="AnalyticsService.getRows" [dataFetchContext]="dataFetchContext" [pageSize]="pageSize" [defaultColumnSort]="{ colId: 'TotalUsers', sort: 'desc' }">

		<!--Column Picker Groups-->
		<vb-ui-column-picker-group [headerName]="'Reports_Column_Group_Event' | translate" [id]="ViewsColumnPickerGroup.EVENT" [isExpanded]="true">
		</vb-ui-column-picker-group>

		<vb-ui-column-picker-group [headerName]="'Reports_Column_Group_Metrics' | translate" [id]="ViewsColumnPickerGroup.METRICS" [isExpanded]="true">
		</vb-ui-column-picker-group>

	</vb-ui-infinite-scroll-grid>
</report-grid-wrapper>
<ng-template #headerTemplate>
	<div layout="row" flex="fill">
		<div [ngClass]="styles.downloadCsv">
			<span [ngClass]="styles.dateRangeText">
				{{ (AnalyticsService.dateFilter$ | async)?.label }}
			</span>
			<button type="button" vbBtnPrimary (click)="initiateEventsCsvDownload()">
				<span class="glyphicons download_alt margin-right-5"></span>
				<span class="xs-hide"> {{ 'Reports_Csv' | translate }}</span>
			</button>
		</div>
	</div>
</ng-template>
